import React, { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faUsers,
  faBook,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Dialog, Transition } from "@headlessui/react";

import Button from "components/Button";
import { zipCodesServed } from "ZIPcodes";

export default function Process() {
  const [serviceable, setServiceable] = useState(false);
  const [zip, setZip] = useState("");
  const [isScheduleDialogOpen, setIsScheduleDialogOpen] = useState(false);

  return (
    <div className="my-24 px-2">
      <p
        className="mb-5 leading-snug tracking-wider text-center text-4xl font-extrabold"
        role="heading"
        aria-level="1"
      >
        The Process
      </p>

      <div className="flex flex-col items-center space-y-10">
        <div className="flex flex-col items-center space-y-3 text-center">
          <div className="w-20 h-20 border-black border-4 font-bold text-2xl rounded-full flex justify-center items-center">
            <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" />
          </div>
          <p>
            <label className="text-xl flex flex-col items-center">
              Check if we serve your ZIP code
              <input
                name="zip"
                type="text"
                maxLength="5"
                autoComplete="off"
                onChange={(e) => {
                  setServiceable(zipCodesServed.includes(e.target.value));
                  setZip(e.target.value);
                }}
                className="w-60 p-2 mt-2 text-center rounded-sm shadow-md border-b-4 border-ciGreen border-opacity-80"
                style={{
                  backgroundColor:
                    serviceable && zip.length > 0
                      ? "rgba(101, 155, 94,0.25)"
                      : !serviceable && zip.length > 4
                      ? "rgba(239, 68, 68, 0.25)"
                      : "#FFFFFF",
                }}
              />
            </label>
          </p>
          {serviceable && (
            <p className="max-w-xs text-ciGreen-light text-lg">
              You're in our service area!
            </p>
          )}
          {!serviceable && zip.length > 4 && (
            <p className="max-w-xs text-red-500 text-lg">
              Sorry, it looks like you live outside of our service area.
            </p>
          )}
        </div>

        <div className="flex flex-col items-center space-y-3 text-center">
          <div className="w-20 h-20 border-black border-4 font-bold text-2xl mb-1 rounded-full flex justify-center items-center">
            <FontAwesomeIcon icon={faCalendarAlt} size="lg" />
            {/* TODO: add calendar modal here */}
            <Transition appear show={isScheduleDialogOpen} as={Fragment}>
              <Dialog
                as="div"
                className="fixed inset-0 z-10 overflow-y-auto"
                onClose={() => setIsScheduleDialogOpen(false)}
              >
                <div className="min-h-screen px-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Dialog.Overlay className="fixed inset-0" />
                  </Transition.Child>

                  {/* This element is to trick the browser into centering the modal contents. */}
                  <span
                    className="inline-block h-screen align-middle"
                    aria-hidden="true"
                  >
                    &#8203;
                  </span>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <div className="inline-block w-full max-w-5xl p-6 my-8 overflow-hidden text-center align-middle transition-all transform bg-white shadow-xl rounded">
                      <Dialog.Title className="text-xl font-medium leading-6">
                        Schedule Your Inspection
                      </Dialog.Title>
                      <div className="mt-2">
                        <object
                          data="https://inspectionsupport.com/core-inspectionllc/online-scheduler/3899349e-d812-11eb-8e29-0a4ef934752f"
                          className="w-full"
                          style={{ height: "50vh" }}
                          type="text/html"
                        >
                          Scheduler
                        </object>
                      </div>

                      <div className="mt-4">
                        <button
                          type="button"
                          className="inline-flex justify-center px-4 py-2 text-sm font-medium bg-ciGreen-light text-white border border-transparent rounded hover:bg-ciGreen-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green-500"
                          onClick={() => setIsScheduleDialogOpen(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </Transition.Child>
                </div>
              </Dialog>
            </Transition>
          </div>
          <Button
            onClick={() => setIsScheduleDialogOpen(true)}
            text="Schedule Your Inspection"
          ></Button>
        </div>

        <div className="flex flex-col items-center space-y-3 text-center">
          <div className="w-20 h-20 border-black border-4 font-bold text-2xl rounded-full flex justify-center items-center">
            <FontAwesomeIcon icon={faUsers} size="lg" />
          </div>
          <p className="text-xl">Our team goes to work</p>
        </div>

        <div className="flex flex-col items-center space-y-3 px text-center">
          <a
            href="https://www.homegauge.com/report/14539356/FullReportForUpload.html"
            target="_blank"
            rel="noreferrer"
            aria-label="Homegauge"
          >
            <div
              className="transform hover:scale-110 motion-reduce:transform-none cursor-pointer w-20 h-20 border-black border-4 font-bold text-2xl rounded-full flex justify-center items-center"
              onClick={() => console.log("binder should open")}
            >
              <FontAwesomeIcon icon={faBook} size="lg" />
            </div>
          </a>
          <p className="text-xl">Your inspection binder is yours forever</p>
        </div>
      </div>
    </div>
  );
}
